import { render } from "./HomeViewLama.vue?vue&type=template&id=8523dab0"
import script from "./HomeViewLama.vue?vue&type=script&lang=js"
export * from "./HomeViewLama.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__